module.exports = __webpack_public_path__ + "static/media/silhouette1.bf5adead.jpeg";